const AUTH_PATHS = new Set([
  "/",
  "/login",
  "/register",
  "/forgot-password",
  "/service-detail",
  "/privacy-policy",
  "/terms-and-conditions",
  "/refund-policy",
  "/security",
]);

export function normalizePath(pathname) {
  const path = String(pathname || "").split("?")[0].replace(/\/+$/, "");
  return path || "/";
}

export function isAuthRoute(pathname) {
  return AUTH_PATHS.has(normalizePath(pathname));
}

export function isLoginEntryPath(pathname) {
  const path = normalizePath(pathname);
  return path === "/" || path === "/login";
}

export function isAllProjectsPath(pathname) {
  return normalizePath(pathname) === "/all-projects";
}

export function isBusinessAppPath(pathname) {
  return normalizePath(pathname).startsWith("/businessprojects");
}

export function isUnauthorizedPath(pathname) {
  return normalizePath(pathname) === "/unauthorized";
}

export function isGoogleOauthCallbackPath(pathname) {
  return normalizePath(pathname) === "/google-oauth-callback";
}
